<template>
    <div class="page-title-area item-bg2">
        <div class="container">
            <div class="page-title-content">
                <h2>Team</h2>
                <p>Meet our team</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PageTitle'
    }
</script>